/* ============================================================
   custom-hero-slideshow.js
   ============================================================ */

(function () {
  function initSlider(wrapper) {
    var track      = wrapper.querySelector('.chs-track');
    var slides     = Array.from(track.querySelectorAll('.chs-slide'));
    var dotsWrap   = wrapper.querySelector('.chs-dots');
    var prevBtn    = wrapper.querySelector('.chs-nav--prev');
    var nextBtn    = wrapper.querySelector('.chs-nav--next');
    var total      = slides.length;
    var current    = 0;
    var timer      = null;
    var autoplayMs = parseInt(wrapper.dataset.autoplay, 10) || 0;

    if (total <= 1) return;

    // Build dots
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'chs-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotsWrap.appendChild(dot);
      });
    }

    function goTo(n) {
      // Remove active from current
      slides[current].classList.remove('is-active');
      if (dotsWrap) dotsWrap.children[current].classList.remove('is-active');

      // Update index
      current = (n + total) % total;

      // Set active on new
      slides[current].classList.add('is-active');
      if (dotsWrap) dotsWrap.children[current].classList.add('is-active');

      // Move track
      track.style.transform = 'translateX(-' + (current * 100) + '%)';

      resetTimer();
    }

    function resetTimer() {
      clearInterval(timer);
      if (autoplayMs > 0) {
        timer = setInterval(function () { goTo(current + 1); }, autoplayMs);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    // Pause autoplay on hover
    wrapper.addEventListener('mouseenter', function () { clearInterval(timer); });
    wrapper.addEventListener('mouseleave', function () { resetTimer(); });

    // Touch / swipe support
    var touchStartX = 0;
    wrapper.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    wrapper.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    resetTimer();
  }

  function init() {
    document.querySelectorAll('.chs-wrapper[data-slider]').forEach(function (wrapper) {
      initSlider(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-init on section reload
  document.addEventListener('shopify:section:load', function (e) {
    var wrapper = e.target.querySelector('.chs-wrapper[data-slider]');
    if (wrapper) initSlider(wrapper);
  });
})();
